(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/barcode/components/manual-info.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/barcode/components/manual-info.js');
"use strict";


const ManualInfo = () => React.createElement(React.Fragment, null, React.createElement("div", {
  className: "padding-top-1 f-400 f-normal"
}, "Kontrollera att koden \xE4r korrekt inmatad."), React.createElement("div", {
  className: "padding-bottom-1 f-400 f-normal"
}, "(Koden manuellt angiven)"));
setGlobal('svs.ticket_gifts.barcode.components.ManualInfo', ManualInfo);

 })(window);